import {
  ADDED_ENTITY_INSIGHTS_METADATA,
  FETCHED_PARTNERSHIP_METADATA,
  REMOVE_ENTITY_INSIGHTS,
  FETCH_ENTITY_CONTENT_INSIGHTS,
  FETCHED_ENTITY_CONTENT_INSIGHTS,
  FETCH_ENTITY_PUBLISHERS_INSIGHTS,
  FETCHED_ENTITY_PUBLISHERS_INSIGHTS,
  FETCH_ENTITY_BRANDS_INSIGHTS,
  FETCHED_ENTITY_BRANDS_INSIGHTS,
  FETCH_ENTITY_HUBS_INSIGHTS,
  FETCHED_ENTITY_HUBS_INSIGHTS,
  FETCH_ENTITY_KEYWORDS_INSIGHTS,
  FETCHED_ENTITY_KEYWORDS_INSIGHTS,
  SET_INSIGHTS_FILTERS,
  FETCHED_BRAND_METADATA,
  FETCHED_PUBLISHER_METADATA,
} from 'components/Pages/Entity/actions';


import {
  AddInsightsEntity,
  AddPartnershipInsightsEntity,
  navigationInsightsEntity,
  RemoveInsightsEntity,
  InsightsEntitySuccessHandler,
  InsightsEntityFetchHandler,
  InsightsEntityListFetchHandler,
  InsightsEntityListSuccessHandler,
  InsightsSetFilterHandler,
} from 'components/Pages/Entity/InsightsUtils.js';

/*
  InsightsReducer.js

  defaultState structure:
    - content: (Object) content insights tab data w/ key for each Entity:
       [entityId]: {
        data: {...},
        fetched: true,
        fetching: false,
        status: 'success',
      },
    - publisher: (Object) publisher insights tab data  w/ key for each Entity
    - keywords: (Object) keywords insights tab data  w/ key for each Entity
    - filters: (Object) filters to be shared between all tabs

 */

const defaultState = {
  filters: {
    startDate: '',
    endDate: '',
    timeInterval: '',
    searchQuery: '',
    topics: [],
    publisher_ids: [],
    brand_ids: [],
    hub_ids: [],
    content_type: 'paid',
    pageSize: 40,
    sort_order: 'desc',
    sort_by: 'num_contents',
  },
  content: {},
  publishers: {},
  brands: {},
  hubs: {},
  keywords: {},
  metadata: {},
};


const InsightsReducer = (state = defaultState, action) => {
  switch (action.type) {
    case '@@router/LOCATION_CHANGE':
      return navigationInsightsEntity(state, action, defaultState);
    case ADDED_ENTITY_INSIGHTS_METADATA:
    case FETCHED_BRAND_METADATA:
    case FETCHED_PUBLISHER_METADATA:
      return AddInsightsEntity(state, action);
    case FETCHED_PARTNERSHIP_METADATA:
      return AddPartnershipInsightsEntity(state, action);
    case REMOVE_ENTITY_INSIGHTS:
      return RemoveInsightsEntity(state, action);
    case FETCH_ENTITY_CONTENT_INSIGHTS:
      return InsightsEntityFetchHandler(state, action, 'content');
    case FETCHED_ENTITY_CONTENT_INSIGHTS:
      return InsightsEntitySuccessHandler(state, action, 'content');
    case FETCH_ENTITY_PUBLISHERS_INSIGHTS:
      return InsightsEntityListFetchHandler(state, action, 'publishers');
    case FETCHED_ENTITY_PUBLISHERS_INSIGHTS:
      return InsightsEntityListSuccessHandler(state, action, 'publishers');
    case FETCH_ENTITY_BRANDS_INSIGHTS:
      return InsightsEntityListFetchHandler(state, action, 'brands');
    case FETCHED_ENTITY_BRANDS_INSIGHTS:
      return InsightsEntityListSuccessHandler(state, action, 'brands');
    case FETCH_ENTITY_HUBS_INSIGHTS:
      return InsightsEntityListFetchHandler(state, action, 'hubs');
    case FETCHED_ENTITY_HUBS_INSIGHTS:
      return InsightsEntityListSuccessHandler(state, action, 'hubs');
    case FETCH_ENTITY_KEYWORDS_INSIGHTS:
      return InsightsEntityListFetchHandler(state, action, 'keywords');
    case FETCHED_ENTITY_KEYWORDS_INSIGHTS:
      return InsightsEntityListSuccessHandler(state, action, 'keywords');
    case SET_INSIGHTS_FILTERS:
      return InsightsSetFilterHandler(state, action);
    default:
      return { ...state };
  }
};

export default InsightsReducer;
